// FILE 15: src/components/ui/Button.js
import React from 'react';
import './Button.css';

/**
 * Reusable button component.
 *
 * @param {'primary'|'secondary'|'ghost'} variant
 * @param {'sm'|'md'|'lg'} size
 * @param {string} [className]
 * @param {React.ReactNode} children
 * @param {object} rest  — forwarded to <button>
 */
export default function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  children,
  ...rest
}) {
  return (
    <button
      className={`btn btn--${variant} btn--${size} ${className}`.trim()}
      {...rest}
    >
      {children}
    </button>
  );
}
